import React from 'react'
import NavLink from 'components/navLink'
import SectionTryQovery from 'components/sections/sectionTryQovery'
import {COMMON} from 'utils/intl/common'
import {getIconSocial} from 'utils'

function Footer(props) {
  const {
    data: {description, socials, links},
    footerIsDark,
    footerVideoTitle,
    footerVideoDescription,
    video,
  } = props

  return (
    <div className={footerIsDark && video ? 'page__footer-dark' : ''}>
      {footerIsDark && video && (
        <SectionTryQovery
          video={video}
          title={footerVideoTitle?.length > 0 ? footerVideoTitle : COMMON.SECTION_TRY_QOVERY_TITLE}
          description={
            footerVideoDescription?.length > 0 ? footerVideoDescription : COMMON.SECTION_TRY_QOVERY_DESCRIPTION
          }
        />
      )}
      <footer
        className={`footer ${footerIsDark ? 'footer--dark' : ''} ${
          footerIsDark && !video ? 'footer--dark-background' : ''
        }`}
      >
        <div className="container">
          <div className="row">
            <div className="footer__left col col-md-4 mb-6 mb-md-0">
              <div className="mb-3">
                {footerIsDark ? (
                  <img loading="lazy" src="../../../images/logo-white.svg" alt="Qovery white logo"/>
                ) : (
                  <img loading="lazy" src="../../../images/logo-black.svg" alt="Qovery black logo"/>
                )}
              </div>
              <div className="footer__infos">
                <p className="mb-3">{description.text}</p>
                <a
                  className={`footer__status mb-5 ft-600 ${footerIsDark ? 'footer__status--dark' : ''}`}
                  href="https://status.qovery.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span></span>
                  Systems Operational
                </a>
                <ul className="f mb-6">
                  {socials.map((social, index) => (
                    <li key={index}>
                      <a
                        className={`link-social ${footerIsDark ? 'link-social--dark-bis' : ''}`}
                        href={social.block.document.data.link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getIconSocial(social.block.document.data.name)}
                      </a>
                    </li>
                  ))}
                </ul>
                <div className="footer__logos">
                  <img
                    className="img-disabled"
                    loading="lazy"
                    src="../../../images/footer-logos.svg"
                    alt="Qovery logos partners"
                  />
                </div>
              </div>
            </div>
            <div className="col col-md-8">
              <div className="footer__lists">
                {links.map((groupLinks, index) => (
                  <div key={index} className="footer__list">
                    <h4 className="ft-700 mb-3">{groupLinks.block.document.data.title.text}</h4>
                    <ul>
                      {groupLinks.block.document.data.links.map((link, i) => (
                        <li key={i}>
                          <NavLink data={link} className="footer__link"/>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="ft-tertiary ft-up">
              <p>© {new Date().getFullYear()} Designed by Qovery</p>
              <p>
                <a className="mr-1" href="https://partners.amazonaws.com/search/partners/?keyword=qovery" target="_blank" rel="noopener noreferrer">
                  AWS Partner
                </a>
                and
                <a href="https://www.g2.com/products/qovery-qovery/reviews" target="_blank" rel="noopener noreferrer">
                  G2 Leader
                </a>
              </p>
              <p>
                Proud silver member of
                <a
                  className="mr-1"
                  href="https://landscape.cncf.io/members?selected=qovery-member"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CNCF
                </a>
                and
                <a href="https://www.linuxfoundation.org/join/members/" target="_blank" rel="noopener noreferrer">
                  Linux foundation
                </a>
              </p>
              <p>Qovery by Birdsight - All rights reserved</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
